// FNP-1191 — READ HALF ONLY. There is deliberately no mutations.ts.
//
// The FNP-1184 schema exposes no zone create/update/delete: writes are spec 2
// and carry their own decisions (change batching, conflict handling, what a
// partial apply means). The port methods and the GraphQL mutations do not exist
// yet, so a mutations file here would be a call to a field that is not on the
// schema — a runtime validation error, not a TODO.

// ⚠️ `failures` IS SELECTED ON THE LIST, AND THAT IS THE POINT OF THIS MODULE.
//
// Omitting it would make a tenant with a broken connection see a SHORTER list
// with no explanation — indistinguishable from having deleted those zones. The
// four failure fields are all rendered: which connection, which provider, the
// provider's verbatim message, and whether retrying could plausibly work.
const DNS_ZONE_FIELDS = `
    id
    name
    connectionId
    provider
    isPrivate
    nameservers
    appearsDelegated
`;

const DNS_CONNECTION_FAILURE_FIELDS = `
    connectionId
    provider
    kind
    message
    retryable
`;

export const listDnsZones = `
   query listDnsZones($connectionId: ID, $limit: Int, $nextToken: String) {
       listDnsZones(connectionId: $connectionId, limit: $limit, nextToken: $nextToken) {
           items {${DNS_ZONE_FIELDS}}
           nextToken
           failures {${DNS_CONNECTION_FAILURE_FIELDS}}
       }
   }
`;

// ⚠️ BOTH ARGUMENTS ARE REQUIRED (`ID!`). A zone id is only meaningful against
// the connection that minted it — the same zone name under two Route 53
// connections is two different zones, and `id` alone cannot tell them apart.
export const getDnsZone = `
   query getDnsZone($connectionId: ID!, $id: ID!) {
       getDnsZone(connectionId: $connectionId, id: $id) {${DNS_ZONE_FIELDS}}
   }
`;

// The connection's capability snapshot, for the write-control hiding decision
// (FNP-1181). Only the capability fields are selected: this module never needs
// the secret ref, and not asking for it is one fewer place it could be logged.
export const getProviderConnectionCapabilities = `
   query getProviderConnection($id: ID!) {
       getProviderConnection(id: $id) {
           id
           status
           capabilities {
               canWriteRecords
               canCreateZones
               canDeleteZones
               canSetNameservers
           }
       }
   }
`;
